/* Landing dron — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'dron'). */


(function(){
var MODELS={
 dron:{name:'Dron Antigolpes a Control Remoto',short:'Dron Antigolpes',compare:239900,
  prices:{1:135900,2:202900,3:269900},
  colors:[{n:'Naranja',h:'#E0752B',stock:41},{n:'Verde',h:'#22A34A',stock:188},{n:'Azul',h:'#2563EB',stock:123}],
  sub:'Imagina la cara de tu hijo cuando el avión despegue por primera vez… y siga volando después del golpe.',
  bullets:['Su primera <b>risa de Navidad</b> empieza cuando despega','Un <b>plan de papá e hijo</b> que se recuerda toda la vida','<b>Aros que protegen</b> las hélices: menos miedo, más vuelo','Si llega dañado o no vuela, <b>lo cambiamos sin costo</b>']},
 planeador:{name:'Planeador Acróbata a Control Remoto',short:'Planeador Acróbata',compare:219900,
  prices:{1:126900,2:184900,3:241900},
  colors:[{n:'Amarillo',h:'#FACC15',stock:50},{n:'Rojo',h:'#EF4444',stock:72},{n:'Azul',h:'#2563EB',stock:62}],
  sub:'Sentirás ese cosquilleo de verlo cruzar el cielo y saber que lo controlas tú. Volar de verdad, sin ser piloto.',
  bullets:['La emoción de <b>verlo despegar</b> y subir hasta perderse en el cielo','<b>Espuma flexible</b>: perdona los errores del primer vuelo','Para volar <b>tú, tu hijo</b> y todos los que se animen','Si llega dañado o no vuela, <b>lo cambiamos sin costo</b>']}
};
/* Dos URLs, una por producto de Shopify: el slug del tema = el modelo (dron | planeador).
   Contrato Shopify (literales para el publicador): __dron_SEL dronTriggerCOD __planeador_SEL planeadorTriggerCOD te_regalo */
var HANDLES={dron:'avion-dron-control-remoto-anti-golpes',planeador:'avion-planeador-control-remoto-acrobata'};
var ON_SHOPIFY=location.pathname.indexOf('/products/')===0;
var qm=(location.search.match(/[?&]m=(dron|planeador)/)||[])[1];
var initModel=location.pathname.indexOf(HANDLES.planeador)>=0?'planeador':(location.pathname.indexOf(HANDLES.dron)>=0?'dron':(qm||'dron'));
var WA='573505802167';
var st={model:initModel,color:MODELS[initModel].colors[0].n,qty:1};
var IMG={
 dron:{video:V('ad-assets/dron-video.mp4'),poster:__A('ad-assets/dron-poster.jpg'),
  c:{Naranja:__A('ad-assets/dron-naranja.jpg'),Verde:__A('ad-assets/dron-verde.jpg'),Azul:__A('ad-assets/dron-azul.jpg')},
  extra:[__A('ad-assets/dron-2.jpg'),__A('ad-assets/dron-3.jpg'),__A('ad-assets/dron-4.jpg')]},
 planeador:{video:V(''),poster:'',
  c:{Amarillo:__A('ad-assets/planeador-amarillo.jpg'),Rojo:__A('ad-assets/planeador-rojo.jpg'),Azul:__A('ad-assets/planeador-azul.jpg')},
  extra:[__A('ad-assets/planeador-2.jpg'),__A('ad-assets/planeador-3.jpg'),__A('ad-assets/planeador-4.jpg')]}
};
function slug(){return st.model}
/* Releasit trae su propio selector de cantidad (radios quantity_offer): preseleccionar el combo elegido en la página */
/* Releasit abre siempre en la 1ª variante: esperamos EVENTOS (no tiempos fijos), bloqueamos el modal mientras se ajusta y fijamos cada color de a uno (cambios solapados rompen su estado) */
function waitFor(fn,max,step,cb){var t=Date.now();(function tick(){var v=fn();if(v)return cb(v);if(Date.now()-t>max)return cb(null);setTimeout(tick,step||50)})()}
function lc(s){return String(s).replace(/\s+/g,' ').trim().toLowerCase()}
function colorSels(d){var names=MODELS[slug()].colors.map(function(c){return lc(c.n)});return [].slice.call(d.querySelectorAll('select')).filter(function(s){return s.offsetParent&&[].some.call(s.options,function(o){return names.indexOf(lc(o.text))>=0})})}
function snap(d){var m=d.innerText.match(/Subtotal[\s\S]*?Total\s*\$[\d.]+/);return m?m[0]:''}
function busy(d,on){d.style.pointerEvents=on?'none':'';var b=d.querySelector('.vl-busy');if(on&&!b){b=document.createElement('div');b.className='vl-busy';b.textContent='Ajustando tu pedido…';b.style.cssText='position:fixed;left:50%;top:14px;transform:translateX(-50%);background:#14284B;color:#fff;font:700 14px Poppins,Arial,sans-serif;padding:8px 18px;border-radius:99px;z-index:9999;box-shadow:0 4px 14px rgba(0,0,0,.3)';d.appendChild(b)}else if(!on&&b)b.remove()}
function fixColors(d,want,guard){
 var s=colorSels(d).filter(function(x){return lc(x.options[x.selectedIndex].text)!==lc(want)})[0];
 if(!s||guard>8){busy(d,false);return}
 var o=[].filter.call(s.options,function(o){return lc(o.text)===lc(want)})[0]; if(!o){busy(d,false);return}
 var before=snap(d),t0=Date.now();
 s.value=o.value;s.dispatchEvent(new Event('input',{bubbles:true}));s.dispatchEvent(new Event('change',{bubbles:true}));
 waitFor(function(){return Date.now()-t0>450&&(snap(d)!==before||Date.now()-t0>1300)},4000,50,function(){fixColors(d,want,guard+1)})
}
function pickOffer(qty,want){
 waitFor(function(){var d=document.querySelector('dialog[open]');return d&&d.querySelector('input[name="quantity_offer"][value="quantity_'+(qty-1)+'"]')},20000,50,function(r){
  if(!r)return; var d=document.querySelector('dialog[open]'); busy(d,true);
  setTimeout(function(){busy(d,false)},15000);
  if(!r.checked)r.click();
  waitFor(function(){return colorSels(d).length>=qty},8000,50,function(){fixColors(d,want,0)})
 })
}
function V(p){return window.__A?window.__A(p):p} /* __A del tema (el publicador no envuelve .mp4) */
function $(s){return document.querySelector(s)}
function fmt(n){return '$'+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.')}
function imgSrc(){return IMG[st.model].c[st.color]}
function ph(color){ /* placeholder cuando aún no hay foto */
 return 'data:image/svg+xml;utf8,'+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><rect width="400" height="400" fill="#F3ECDD"/><path d="M60 230l280-90-70 120-60-30-40 60-20-70z" fill="'+color+'" opacity=".9"/></svg>');
}
function setImg(el,src,color){el.onerror=function(){el.onerror=null;el.src=ph(color)};el.src=src}
function cur(){return MODELS[st.model]}
var galModel=null, slides=[];
function slideSrcs(){var m=IMG[st.model];return [{t:'vid',s:m.video},{t:'img',s:imgSrc()},{t:'img',s:m.extra[0]},{t:'img',s:m.extra[1]},{t:'img',s:m.extra[2]}]}
function buildGallery(){
 var items=slideSrcs(), tr=$('#track'), th=$('#thumbs'), dots=$('#dots');
 tr.innerHTML=''; th.innerHTML=''; dots.innerHTML='';
 var hex=colorHex();
 items.forEach(function(it,i){
  var sl=document.createElement('div'); sl.className='slide';
  var th1=document.createElement('button'); th1.type='button'; th1.className='thumb'; th1.setAttribute('aria-label','Ver '+(i+1));
  var d=document.createElement('i'); dots.appendChild(d);
  if(it.t==='img'){
   var im=document.createElement('img'); im.alt=cur().short+' '+(i+1);
   var t2=document.createElement('img'); t2.alt='';
   if(i===1){setImg(im,it.s,hex); setImg(t2,it.s,hex)}
   else{ var drop=function(){sl.remove();th1.remove();d.remove();mark(Math.round(tr.scrollLeft/tr.clientWidth))}; im.onerror=drop; t2.onerror=function(){}; im.src=it.s; t2.src=it.s }
   sl.appendChild(im); th1.appendChild(t2);
  }else{
   var v=document.createElement('video'); v.muted=true; v.loop=true; v.playsInline=true; v.setAttribute('playsinline',''); v.preload='metadata'; v.poster=IMG[st.model].poster; v.src=it.s;
   v.onerror=function(){v.onerror=null; var p=document.createElement('img'); p.alt='Video'; p.src=ph(hex); v.replaceWith(p)};
   sl.appendChild(v); var pi=document.createElement('img'); pi.alt=''; pi.onerror=function(){pi.onerror=null;pi.src=ph(hex)}; pi.src=IMG[st.model].poster; th1.appendChild(pi); var pl=document.createElement('span'); pl.className='pl'; pl.textContent='▶'; th1.appendChild(pl);
  }
  th1.onclick=function(){go(i)};
  tr.appendChild(sl); th.appendChild(th1);
 });
 tr.scrollLeft=0; mark(0);
}
function updateFirst(){var im=document.querySelectorAll('#track .slide')[1].querySelector('img'); if(im)setImg(im,imgSrc(),colorHex()); var t=document.querySelectorAll('#thumbs .thumb')[1].querySelector('img'); if(t)setImg(t,imgSrc(),colorHex()); go(1)}
function go(i){var tr=$('#track'); tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'})}
function mark(i){document.querySelectorAll('#thumbs .thumb').forEach(function(e,k){e.classList.toggle('on',k===i)});document.querySelectorAll('#dots i').forEach(function(e,k){e.classList.toggle('on',k===i)});
 var v=document.querySelector('#track video'); if(v){if(i===0){var p=v.play();if(p&&p.catch)p.catch(function(){})}else v.pause()}}
(function(){var tr=document.getElementById('track'); var raf;
 tr.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){mark(Math.round(tr.scrollLeft/tr.clientWidth))})},{passive:true});
 document.getElementById('prev').onclick=function(){var i=Math.round(tr.scrollLeft/tr.clientWidth);go(Math.max(0,i-1))};
 document.getElementById('next').onclick=function(){var i=Math.round(tr.scrollLeft/tr.clientWidth);go(Math.min(document.querySelectorAll('#track .slide').length-1,i+1))};
})();
function colorHex(){var c=cur().colors.filter(function(x){return x.n===st.color})[0];return c?c.h:'#0B63CE'}
function render(){
 var m=cur();
 $('#title').textContent=m.name; $('#subtitle').textContent=m.sub;
 $('#bullets').innerHTML=m.bullets.map(function(b){return '<li>'+b+'</li>'}).join('');
 $('#badge').textContent='-'+Math.round((1-m.prices[1]/m.compare)*100)+'%';
 if(galModel!==st.model){galModel=st.model;buildGallery()}else{updateFirst()}
 document.querySelectorAll('.model').forEach(function(b){b.classList.toggle('on',b.dataset.model===st.model)});
 $('#colors').innerHTML=m.colors.map(function(c){return '<button type="button" class="color'+(c.n===st.color?' on':'')+'" data-c="'+c.n+'"><i style="background:'+c.h+'"></i>'+c.n+'</button>'}).join('');
 var rows=[1,2,3].map(function(q){
  var p=m.prices[q], per=Math.round(p/q/100)*100, save=m.prices[1]*q-p;
  return '<button type="button" class="bundle'+(q===st.qty?' on':'')+'" data-qty="'+q+'">'+(q===2?'<span class="tag">MÁS POPULAR</span>':'')+(q===3?'<span class="tag">MEJOR PRECIO</span>':'')+
   '<span class="radio"></span><span class="t">'+q+(q===1?' unidad':' unidades')+'<small>'+(q===1?'Precio de lanzamiento':'Ahorras '+fmt(save)+' · ≈ '+fmt(per)+' c/u')+'</small></span><span class="p">'+fmt(p)+(q===1?'<s>'+fmt(m.compare)+'</s>':'')+'</span></button>';
 });
 $('#bundles').innerHTML=rows.join('');
 var col=m.colors.filter(function(x){return x.n===st.color})[0];
 document.querySelectorAll('[data-for]').forEach(function(e){e.hidden=e.dataset.for!==st.model});
 var low=col&&col.stock<100, msg=low?'🔥 Quedan solo '+col.stock+' en '+st.color.toLowerCase()+' · se agotan rápido':'⚡ Stock limitado por color · pide ya el tuyo';
 $('#stock').textContent=msg; $('#stock2').textContent=msg;
 var pct=col?Math.max(8,Math.min(92,Math.round(col.stock/2.2))):30; $('#stockbar').style.width=pct+'%'; $('#stockbar2').style.width=pct+'%';
 var p=m.prices[st.qty];
 $('#finalPrice').innerHTML=fmt(p)+(st.qty===1?' <s>'+fmt(m.compare)+'</s>':'');
 $('#stTitle').textContent=m.short+' · '+st.color+' x'+st.qty; $('#stPrice').textContent=fmt(p);
}
document.addEventListener('click',function(e){
 var t;
 if((t=e.target.closest('.model'))){
  if(ON_SHOPIFY&&t.dataset.model!==st.model){location.href='/products/'+HANDLES[t.dataset.model]+location.search;return}
  st.model=t.dataset.model;st.color=cur().colors[0].n;render();}
 else if((t=e.target.closest('.color'))){st.color=t.dataset.c;render();}
 else if((t=e.target.closest('.bundle'))){st.qty=+t.dataset.qty;render();}
});
document.querySelectorAll('.model img').forEach(function(i){
 var c=i.closest('.model').dataset.model==='dron'?'#E0752B':'#FACC15';
 function fb(){i.onerror=null;i.src=ph(c)}
 i.onerror=fb; if(i.complete&&i.naturalWidth===0)fb();
});
/* punto de compra único (Contrato Shopify) */
window.openOrder=function(){
 var on=document.querySelector('.bundle.on'); var qty=on?+on.dataset.qty:1;
 window['__'+slug()+'_SEL']={model:st.model,color:st.color,qty:qty};
 try{localStorage.setItem('te_regalo',slug()+'|'+Date.now())}catch(e){}
 if(window[slug()+'TriggerCOD']&&window[slug()+'TriggerCOD']()!==false){pickOffer(qty,st.color);return}
 var m=cur(), txt=m.short+' · '+st.color+' · '+qty+(qty===1?' unidad':' unidades')+' · '+fmt(m.prices[qty])+' (pago al recibir)';
 $('#modalTxt').textContent=txt;
 $('#modalWa').href='https://wa.me/'+WA+'?text='+encodeURIComponent('Hola, quiero pedir: '+txt);
 $('#modal').classList.add('on');
};
/* sticky tras el primer scroll */
var sticky=$('#sticky');
function onScroll(){sticky.classList.toggle('show',window.scrollY>window.innerHeight*0.6)}
window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
/* ===== punch: cuenta regresiva real a Navidad, revelado, contadores, wiggle ===== */
function xmasDays(){var n=new Date(),y=n.getFullYear(),x=new Date(y,11,24);if(n>x)x=new Date(y+1,11,24);return Math.max(0,Math.ceil((x-n)/86400000))}
document.querySelectorAll('.xd').forEach(function(e){e.textContent=xmasDays()});
var io=null;
if('IntersectionObserver' in window){
 io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('in');
  if(e.target.classList.contains('stat')){var c=e.target.querySelector('.cnt');if(c&&!c.dataset.d){c.dataset.d=1;var t=+c.dataset.n,i=0,iv=setInterval(function(){i++;c.textContent=Math.min(t,i);if(i>=t)clearInterval(iv)},260)}}
  io.unobserve(e.target)})},{threshold:.18});
 document.querySelectorAll('.rv').forEach(function(e){io.observe(e)});
}else{document.querySelectorAll('.rv').forEach(function(e){e.classList.add('in')});document.querySelectorAll('.cnt').forEach(function(c){c.textContent=c.dataset.n})}
var sv=document.querySelectorAll('.vids video');
if(sv.length&&'IntersectionObserver' in window){var vo=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){})}else v.pause()})},{threshold:.35});sv.forEach(function(v){vo.observe(v)})}
document.querySelectorAll('[data-pick]').forEach(function(b){b.addEventListener('click',function(){
 var m=b.dataset.pick; var el=document.querySelector('.model[data-model="'+m+'"]'); if(el)el.click();
 var top=document.getElementById('top'); if(top)top.scrollIntoView({behavior:'smooth',block:'start'});
})});
setInterval(function(){var b=document.querySelector('.hero-cta .btn');if(b){b.classList.remove('wig');void b.offsetWidth;b.classList.add('wig')}},7000);
/* pop-up de compras: SOLO pedidos reales de Shopify de este producto (nombre de pila + ciudad + fecha). Sin pedidos = no aparece.
   Actualizar con "Claude, refresca los pedidos del pop-up" (consulta Shopify, excluye pruebas/cancelados/duplicados). Último refresco: 22-oct-2026 */
var ORDERS={
 dron:[
  {n:'Rivas',c:'Montería',col:'Naranja',t:'2026-10-22T13:50:47Z'},
  {n:'Aldemar',c:'Bogotá',col:'Naranja',t:'2026-10-22T13:00:40Z'},
  {n:'Nicolas',c:'Inzá',col:'Azul',t:'2026-10-21T01:05:17Z'},
  {n:'Julio',c:'Bogotá',col:'Azul',t:'2026-10-20T23:34:32Z'},
  {n:'Wilfredy',c:'Medellín',col:'',t:'2026-10-20T16:52:22Z'}],
 planeador:[]};
(function(){
 var list=(ORDERS[slug()]||[]).filter(function(o){return Date.now()-new Date(o.t).getTime()<7*864e5});
 try{if(sessionStorage.getItem('ped_pop_off'))return}catch(e){}
 if(!list.length)return;
 function ago(t){var m=Math.max(1,Math.round((Date.now()-new Date(t).getTime())/6e4));
  if(m<60)return 'hace '+m+' min'; var h=Math.round(m/60); if(h<24)return 'hace '+h+(h===1?' hora':' horas'); var d=Math.round(h/24); return 'hace '+d+(d===1?' día':' días')}
 var el=document.createElement('div'); el.className='ped-pop'; el.setAttribute('role','status'); el.setAttribute('aria-live','polite');
 el.innerHTML='<span class="ped-ic" aria-hidden="true">🛒</span><div class="ped-tx"></div><button type="button" class="ped-x" aria-label="Cerrar">×</button>';
 (document.querySelector('.'+slug()+'-landing')||document.body).appendChild(el); /* en Shopify el CSS va bajo .{slug}-landing: fuera del contenedor no tendría estilos */
 var tx=el.querySelector('.ped-tx'), i=0, off=false, tm;
 el.querySelector('.ped-x').onclick=function(){off=true;el.classList.remove('on');try{sessionStorage.setItem('ped_pop_off','1')}catch(e){}};
 function show(){
  if(off)return;
  if(document.querySelector('dialog[open]')){tm=setTimeout(show,4000);return}
  var o=list[i%list.length]; i++;
  tx.innerHTML='<b>'+o.n+'</b> de '+o.c+' pidió el '+cur().short.replace('Dron Antigolpes','Dron Antigolpes')+(o.col?' '+o.col:'')+'<small>'+ago(o.t)+' · pago contra entrega</small>';
  el.classList.add('on');
  tm=setTimeout(function(){el.classList.remove('on');tm=setTimeout(show,14000)},6000);
 }
 tm=setTimeout(show,8000);
})();
render();
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__dron_SEL || {};
    var V = window.DRON_VARIANTS || [];
    var n = function (x) { return String(x || '').toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); };
    var v = V.filter(function (x) {
      return n(x.color) === n(s.color) && (s.size == null || String(x.talla) === String(s.size));
    })[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__dron-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  /* ¿Está abierto el modal de Releasit? (<dialog class="rsi-form-wrap"> con open) */
  function rsiOpen() {
    var d = document.querySelectorAll('dialog');
    for (var i = 0; i < d.length; i++) { if (d[i].open && /rsi/.test(String(d[i].className))) return true; }
    return false;
  }

  /* UN solo click debe abrir el formulario. Si el cliente toca antes de que Releasit termine de
     cargar (botón aún sin enganchar), el primer click se perdía y hacían falta dos: ahora se
     reintenta hasta confirmar que el modal abrió (máx. ~15 s). */
  window.dronTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    if (window.dron_opening) clearInterval(window.dron_opening);
    var tries = 0;
    function attempt() {
      sync();
      var b = findReleasitButton();
      if (b) b.click();
      else if (tries > 20 && window._rsiV2 && typeof window._rsiV2.setState === 'function') {
        try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
      }
    }
    setTimeout(function () {
      attempt();
      window.dron_opening = setInterval(function () {
        tries++;
        if (rsiOpen() || tries > 18) { clearInterval(window.dron_opening); return; }
        attempt();
      }, 800);
    }, 50);
  };
})();
